<div [class.card]="cardClass">
  <div [class.card-body]="cardClass">
    <h5 class="card-title d-block d-md-flex justify-content-between">
      <div class="mb-2 mb-md-0"><i class="mr-2 text-primary fs-28" [ngClass]="activity.icon"></i>{{ activity.title }}</div>
      <div class="d-flex align-items-baseline">
        <small *ngIf="activity.required && activity.status != 'Closed'" class="badge-outline-primary badge font-weight-light mt-2 mr-3"> Required</small>
        <common-status-label *ngIf="showStatus" class="ml-auto" [status]="activity.status" labelStyle="status-pill"></common-status-label>
      </div>
    </h5>
    <div *ngIf="activity.status == 'PendingReview'" class="alert my-3 font-weight-light" [ngClass]="pendingReviewBanner.class" role="alert">
      {{ pendingReviewBanner.message }}
    </div>

    <div *ngIf="activity.status == 'Denied' && activity.metadata?.deniedReason" class="alert alert-danger my-3 font-weight-light" role="alert">
      Denied Reason: {{ activity.metadata?.deniedReason || "Please contact Rubbl support at (866) 455-8531." }}
    </div>
    <p class="card-text font-weight-light" [innerHtml]="activity.description"></p>
    <ng-content></ng-content>
    <p class="mt-3">
      <small class="text-muted mr-auto" *ngIf="activity.status == 'Closed'">Completed on {{ activity.completedDateTime | date : "MMM d, h:mm a" }} </small>
    </p>
    <div class="card mt-5" *ngIf="environment.clientId == 'rubbl.admin'">
      <div class="card-header">Admin Actions</div>
      <div class="card-body">
        <ng-container *ngIf="activity.requiresAdminApproval && (activity.status == 'PendingReview' || activity.status == 'Dismissed')">
          <button class="btn btn-block btn-mobile btn-secondary" (click)="approve()">Approve</button>
          <button class="btn btn-block btn-mobile btn-outline-secondary mt-2" (click)="deny()">Deny</button>
        </ng-container>

        <button class="btn btn-block btn-mobile btn-outline-secondary mt-2" (click)="resetActivity()">Reset</button>

        <common-show-entity-json label="Activity (Cosmos)" [entity]="activity"></common-show-entity-json>
      </div>
    </div>
  </div>
</div>
